import { FS_HITS } from '../flagship/constants';
import { WrapperPromise } from '../flagship/type';
import { removeForcedVariationsInStorage } from '../flagship/utils';
import { AB_TASTY_QA_ASSISTANT_NOTIFICATION } from '../tag/Header/EventNotification/EventNotification';
import { SESSION_STORAGE_SAVED_NAV } from './components/Header/Navigation/Navigation';
import { FS_ENV_ID } from './constants';

export function hasFsEnvIdQuery() {
  const params = new URL(document.location.toString()).searchParams;
  return params.has(FS_ENV_ID);
}

type PromiseStatus = 'pending' | 'success' | 'error';

export function wrapPromise<T>(promise: Promise<T>): WrapperPromise<T> {
  let status: PromiseStatus = 'pending';
  let result: T | undefined;
  const suspender = promise.then(
    (r) => {
      status = 'success';
      result = r;
    },
    (e) => {
      status = 'error';
      result = e;
    }
  );
  return {
    read() {
      switch (status) {
        case 'pending':
          throw suspender;
        case 'error':
          throw result;
        case 'success':
          return result;
        default:
          throw new Error(`Unexpected status: ${status}`);
      }
    },
  };
}

/**
 * Return a formatted string
 */
export function sprintf(format: string, ...values: unknown[]): string {
  return format.replace(/{(\d+)}/g, (match, index) => {
    const value = values[Number(index)];
    if (typeof value === 'string') {
      return value;
    }
    if (value instanceof Map) {
      return JSON.stringify(Array.from(value.values()));
    }
    return JSON.stringify(value);
  });
}

export function onQaAssistantClosing() {
  removeForcedVariationsInStorage();
  sessionStorage.setItem(AB_TASTY_QA_ASSISTANT_NOTIFICATION, '0');
  sessionStorage.setItem(FS_HITS, '[]');
  sessionStorage.removeItem(SESSION_STORAGE_SAVED_NAV);
}
